export const faqData = [
  {
    question: "What are NFC business cards?",
    answer:
      "NFC business cards are smart cards embedded with a chip that allows instant sharing of your contact details, social links, and business information with a simple tap on a smartphone.",
  },
  {
    question: "Do NFC cards work with all phones?",
    answer:
      "Yes! Most modern Android and iOS devices support NFC. For older phones without NFC, your card also includes a QR code for easy scanning.",
  },
  {
    question: "Can I update my digital profile later?",
    answer:
      "Absolutely. You can log in to your dashboard anytime and edit your contact info, social links, and company details — changes update instantly on your NFC card.",
  },
  {
    question: "Is there a monthly subscription fee?",
    answer:
      "No monthly fees! You pay once for your NFC card. Optional premium features like analytics or custom designs may have additional costs.",
  },
  {
    question: "Do you offer bulk or team discounts?",
    answer:
      "Yes, we offer special pricing for teams, companies, and event orders. Contact our sales team for customized bulk pricing.",
  },
  {
    question: "About TapOnn Smart Business Cards",
    answer: `TapOnn's smart business card is a revolutionary way to share your contact information and connect with others. With its advanced NFC technology, you can easily share your contact details, social media links, and website links with just one tap.

Smart Solutions from TapOnn eliminates the need for Paper Visiting Cards and makes it easier to connect with others. Whether you are a business professional, freelancer, or just looking to expand your network, TapOnn's smart business card is perfect for increasing your networking capabilities.

Its sleek and modern design makes it a stylish and professional choice for sharing your information with others. So, if you want to take your networking to the next level, TapOnn's smart business card is the way to go.`,
  },
  {
    question: "What is a smart business card?",
    answer: `A smart business card is a physical card that contains a small chip that can be read by NFC (Near Field Communication) enabled devices. This chip allows you to store and share your personal and professional information with others simply by tapping your card against their device.`,
  },
  {
    question: "Are smart business cards worth it?",
    answer: `Smart business cards are a convenient and professional way to share your contact information with others. It lets you easily share your information with others simply by tapping your card against their device. It updates your details quickly saving you from the hassle of printing cards again and again. Most importantly, It helps you make connections without losing it.`,
  },
  {
    question: "Impact of smart cards on business",
    answer: `The impact of smart cards in business is significant, as they allow for easy and efficient networking and sharing of contact details. With a smart business card, you can quickly and easily share your information with potential clients, business partners, and other professionals, saving time and effort.`,
  },
  {
    question: "What is an NFC Business Card?",
    answer: `An NFC business card is a physical card that contains an NFC chip, allowing you to share your contact details with others by tapping your card against their device.`,
  },
  {
    question: "Single Tap NFC Innovations for Sharing Information",
    answer: `1. Smart business cards: These are physical cards that contain an NFC chip, allowing you to share your contact details with others simply by tapping your card against their device.
2. Smart Coins: TapOnn's smart coins are a smart and convenient way to increase your networking efforts and elevate your personal brand. Whether you are attending a business event, networking with potential clients, or just meeting new people, TapOnn's smart coins make it easy to share your contact information and connect with others.
3. Smart Sockets: Smart sockets are a revolutionary new way to increase your networking efforts and elevate your personal brand. TapOnn's smart sockets, which are based on NFC (near-field communication) technology, allow users to quickly and easily share their contact information with others by simply tapping their phone against the socket.`,
  },
  {
    question: "What is 90-Day Satisfaction Policy ?",
    answer: `At TapOnn, we're committed to ensuring your complete satisfaction with our smart product. That's why we offer a comprehensive 90-day policy that allows you to experience the full potential of efficient networking without any risk.

How It Works:
From the day of your TapOnn smart product purchase, you have a 90-day window to explore seamless networking possibilities. If, after this period (between 90 - 120 days), you find that our product doesn't meet your expectations, we've got you covered.

Our Promise:
In the event that you're not entirely satisfied with your TapOnn smart product after 90 days, you can reach out to us at support@taponn.digital. Our dedicated team will process your request promptly, and we will refund the entire amount of your purchase.

For complete details on our 90-day satisfaction guarantee policy, please review our Terms and Conditions here: /pages/terms-conditions`,
  },
];
